import React from "react"

interface Props {
  children: React.ReactNode
}

export const ButtonList = ({ children }: Props) => (
  <div className="button-list">{children}</div>
)
